import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  cursor: pointer;
`;

const EventIcon = ({ width = 27, height = 31, color = '#000' }) => (
  <Wrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 31"
      fill={color}
      style={{ display: 'block', margin: 'auto' }}
    >
      <path
        data-name="Path 371"
        d="M20.029 16.346l-1.374-1.5L11.8 21.7l-3.426-3.578-1.407 1.471 4.8 5.021z"
      />
      <path
        data-name="Path 372"
        d="M7.3 0h-.883a2.378 2.378 0 00-2.324 2.429v.347h-.445A3.737 3.737 0 000 6.593v20.59A3.737 3.737 0 003.651 31h19.7A3.737 3.737 0 0027 27.183V6.6a3.736 3.736 0 00-3.651-3.817h-.445v-.347A2.378 2.378 0 0020.58 0h-.883a2.378 2.378 0 00-2.323 2.43v.347H9.626V2.43A2.378 2.378 0 007.306 0zM6.081 2.429a.34.34 0 01.332-.347H7.3a.34.34 0 01.332.347V5.2a.34.34 0 01-.332.347h-.883a.339.339 0 01-.332-.347zm18.921 24.754a1.7 1.7 0 01-1.66 1.735H3.648a1.7 1.7 0 01-1.659-1.735V11.84h23.016zM19.359 2.429a.34.34 0 01.332-.347h.886a.339.339 0 01.332.347V5.2a.339.339 0 01-.332.347h-.883a.34.34 0 01-.332-.347zm-1.992 2.429V5.2a2.378 2.378 0 002.324 2.429h.886A2.378 2.378 0 0022.9 5.2v-.347h.441a1.7 1.7 0 011.66 1.735v3.158H1.988V6.593a1.7 1.7 0 011.659-1.735h.442V5.2a2.377 2.377 0 002.323 2.429h.887A2.377 2.377 0 009.622 5.2v-.347z"
      />
    </svg>
  </Wrapper>
);

export default EventIcon;
